import { Outlet } from "react-router-dom";
import { FullScreenPage } from "../FullScreenPage";
import { AppBreadCrumbs } from "components/breadcrubs/AppBreadcrumbs";
import { Container, createStyles, Title } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  root: {
    backgroundColor: theme.white,
    height: "100%",
  },
}));

// TODO fix types and appbar
export const SimpleFullScreenPageWithAppBarAndTitle = ({
  title,
  order,
  children,
}: any) => {
  const { classes } = useStyles();
  return (
    <FullScreenPage>
      <div className={classes.root}>
        {/* <MainAppBar /> */}
        <Container>
          <AppBreadCrumbs />
          <Title order={order} align="center" m="xl">
            {title}
          </Title>
          {children}
          <Outlet />
        </Container>
      </div>
    </FullScreenPage>
  );
};
